import { Tooltip, Typography, TypographyProps } from "@material-ui/core";

type Props = {
  text: string;
  maxWidth?: number | string;
} & Omit<TypographyProps, "children" | "noWrap">;

export default function TruncatedText({
  text,
  maxWidth,
  style,
  ...props
}: Props) {
  return (
    <Tooltip title={text}>
      <Typography noWrap style={{ ...style, maxWidth }} {...props}>
        {text}
      </Typography>
    </Tooltip>
  );
}
